module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    staticClass: "fa",
    class: _vm.iconClass,
    style: ({
      fontSize: _vm.fontSize
    }),
    attrs: {
      "aria-hidden": "true"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62ea29dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/icon/icon.vue
// module id = 806
// module chunks = 10